export default __webpack_public_path__ + "static/media/back-arrow.43695ba6.png";